<template>
	<div class="section-infopartners">
		<p class="text-h5 mb-6 font-weight-bold text-center primary--text">Мы благодарим наших партнеров</p>
		<v-row
			class="section-infopartners__logos align-center mx-auto d-flex justify-center">
			<div v-for="Item in ItemsRowOne" class="my-2 my-sm-1" :key="Item.id">
				<a :href="Item.url" target="_blank">
					<v-img :src="Item.image" contain :aspect-ratio="Item.aspect" :max-width="Item.width" class="mx-auto pa-0" />
				</a>
			</div>
		</v-row>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionPartners',
	data: () => ({
		ItemsRowOne: [
			{
				id: 0,
				image: require('@/assets/images/partners/2025/bosco.svg'),
				url: 'https://bosco.ru/',
				width: 286,
				aspect: 286/140
			},
			{
				id: 1,
				image: require('@/assets/images/partners/2025/kuper.svg'),
				url: 'https://web.kuper.ru/',
				width: 286,
				aspect: 286/140
			},
			{
				id: 2,
				image: require('@/assets/images/partners/2025/ingostrah.svg'),
				url: 'https://www.ingos.ru/',
				width: 286,
				aspect: 286/140
			},
			{
				id: 3,
				image: require('@/assets/images/partners/2025/milk.svg'),
				url: 'https://logikamoloka.ru/',
				width: 286,
				aspect: 286/140
			},
			{
				id: 4,
				image: require('@/assets/images/partners/2025/petelinka.svg'),
				url: 'https://petelinka.ru/',
				width: 286,
				aspect: 286/140
			},
			{
				id: 5,
				image: require('@/assets/images/partners/2025/psb.svg'),
				url: 'http://psbank.ru',
				width: 286,
				aspect: 286/126
			},
			{
				id: 6,
				image: require('@/assets/images/partners/2025/t2.svg'),
				url: 'https://t2.ru/',
				width: 202,
				aspect: 202/126
			},
			{
				id: 7,
				image: require('@/assets/images/partners/2025/dgp.svg'),
				url: 'https://www.mos.ru/dgp/',
				width: 270,
				height: 270/126
			},
			{
				id: 8,
				image: require('@/assets/images/partners/2025/sbp.svg'),
				url: 'https://vamprivet.ru/',
				width: 270,
				aspect: 270/126
			}
		] as Array<partnerLink>,
		ItemsRowTwo: [			
		] as Array<partnerLink>,
	}),
});

class partnerLink {
	id!: number;
	image!: string;
	url!: string;
	width!: number;
	aspect!: number;
}
</script>

<style lang="scss">
.section-infopartners__logos {
	max-width: 1400px;

	.section-infopartners__logo {
		width: 100%;
		@media (min-width: 442px) {
			&:last-of-type {
				margin-bottom: 2rem;
			}
		}
	}
}
</style>
